import React from "react";
import { useNavigate } from "react-router-dom";
import './ToolPage.css';
import { playSound } from '../utils/soundPlayer';
import { useTranslation } from 'react-i18next'; // ✅

const ToolPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // ✅

  return (
    <div className="tool-page-container">
      <button className="back-button" onClick={() => {
        playSound('return');
        navigate('/menu');
      }}>
        {t('tool.back')}
      </button>

      <h2 className="tool-page-title">{t('tool.title')}</h2>

      <div className="tool-grid">
        <div
          className="tool-card"
          onClick={() => navigate('/tools/card-search')}
          style={{ backgroundImage: "url('/icons/cardsearch.png')" }}
        >
          <div className="tool-card-content">
            <h3>{t('tool.cardSearch')}</h3>
            <p>{t('tool.cardSearchDescription')}</p>
          </div>
        </div>
        <div
          className="tool-card"
          onClick={() => navigate('/tool/time-limit')}
          style={{ backgroundImage: "url('/icons/timelimit.png')" }} // 💡 Change the path if needed
        >
          <div className="tool-card-content">
            <h3>{t('tool.timeLimit')}</h3>
            <p>{t('tool.timeLimitDescription')}</p>
          </div>
        </div>
        <div
          className="tool-card leaderpanel-card"
          onClick={() => navigate('/leaderboard')}
          style={{ backgroundImage: "url('/icons/ygometa.png')" }} // 💡 Change the path if needed
        >
          <div className="tool-card-content ">
            <h3>{t('tool.yugiohMeta')}</h3>
            <p>{t('tool.yugiohMetaDescription')}</p>
          </div>
        </div>
        <div
          className="tool-card"
          onClick={() => navigate('/deckbuilder')}
          style={{ backgroundImage: "url('/icons/combo.png')" }} // You can customize this image
        >
          <div className="tool-card-content">
            <h3>{t('tool.deckBuilder')}</h3>
            <p>{t('tool.deckBuilderDescription')}</p>
          </div>
        </div>
        <div
          className="tool-card"
          onClick={() => navigate('/leaderboard-archives')}
          style={{ backgroundImage: "url('/icons/leaderpanel.png')" }}
        >
          <div className="tool-card-content">
            <h3>{t('tool.leaderboardArchives')}</h3>
            <p>{t('tool.leaderboardArchivesDescription')}</p>
          </div>
        </div>
      </div>

      <div className="more-tools">
        🛠️ <span>{t('tool.moreSoon')}</span>
        <span className="dots"><span>.</span><span>.</span><span>.</span></span>
      </div>
    </div>
  );
};

export default ToolPage;
